export const SPINNER_SHOW_CLASS = 'is-spinner-shown';
